import './footer.css'
import img from '../../utils/jagu-logo/jagu-white-logo.png'

import facebooklogo from '../../utils/social-media/Facebook_logo_(square).png'
import instalogo from '../../utils/social-media/Instagram_icon.png'
import tiktoklogo from '../../utils/social-media/tiktok-logo-tiktok-logo-transparent-tiktok-icon-transparent-free-free-png.png'
import youtubelogo from '../../utils/social-media/Youtube_logo.png'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <>
      <div className="footer-container">
        <Link to="/" className="logo-and-name">
          <img className="img-logo" src={img} alt="logo" />
          <h1>JAGU-MOOK</h1>
        </Link>

        <div className="contacts-container">
          <h1 className="first-footer-blok">Контакты</h1>
          <div className="second-footer-blok">
            <div className="address-control">
              <span>+996312111111</span>
              <span>jagu-mook@jagu.edu.kg</span>
            </div>

            <div className="address-control">
              <span>ул.МКР.СПУТНИК-14 2</span>
              <span>гр. МАНАС</span>
            </div>

            <div className="social-contacts">
              <a href="https://www.instagram.com/jagu_kg_/">
                <img src={instalogo} alt="instalogo" />
              </a>
              <a href="https://www.youtube.com/@JAGU-EDU">
                <img src={youtubelogo} alt="youtubelogo" />
              </a>

              <img src={tiktoklogo} alt="tiktoklogo" />
              <a href="https://www.facebook.com/admin.jagu/">
                <img src={facebooklogo} alt="facebooklogo" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="end"> </div>
    </>
  )
}

export default Footer
